import React from 'react';

const LiquidFolder = ({ items = [], color = '#1DB954', className = '' }) => {
    return (
        <div className={`relative w-64 h-48 mx-auto mt-10 group cursor-pointer ${className}`}>

            {/* BACK GLOW */}
            <div
                className="absolute inset-0 rounded-xl blur-2xl opacity-40"
                style={{
                    background: `radial-gradient(circle at 50% 20%, ${color}, transparent 70%)`,
                }}
            />

            {/* BACK PLATE (SOFT LIQUID SURFACE) */}
            <div
                className="absolute inset-0 rounded-xl transition-transform duration-500 ease-out group-hover:scale-105"
                style={{
                    background: `linear-gradient(140deg, ${color}80, ${color}40)`,
                    transform: "perspective(1000px) rotateX(6deg)",
                }}
            />

            {/* STACKED ITEMS */}
            <div className="absolute inset-x-4 bottom-4 h-3/4 flex items-end justify-center space-x-[-20px] z-10">
                {items.map((item, index) => (
                    <div
                        key={index}
                        className="relative transition-all duration-500 ease-out group-hover:-translate-y-16 group-hover:rotate-0"
                        style={{
                            transform: `rotate(${index % 2 === 0 ? -6 : 6}deg) translateY(0)`,
                            zIndex: index,
                            transitionDelay: `${index * 60}ms`,
                        }}
                    >
                        <div className="w-24 h-32 bg-white/90 rounded-lg shadow-xl overflow-hidden border border-gray-200 flex items-center justify-center">
                            {item}
                        </div>
                    </div>
                ))}
            </div>

            {/* FRONT LIQUID GLASS */}
            <div
                className="absolute inset-0 z-20 rounded-xl border border-white/30 shadow-2xl backdrop-blur-xl transition-all duration-500 group-hover:backdrop-blur-2xl"
                style={{
                    background: `
                        linear-gradient(135deg, rgba(255,255,255,0.45), rgba(255,255,255,0.08)),
                        linear-gradient(120deg, rgba(255,255,255,0.7) 0%, transparent 60%)
                    `,
                    boxShadow: `
                        0 10px 30px rgba(0,0,0,0.25),
                        inset 0 0 25px rgba(255,255,255,0.3)
                    `,
                }}
            >

                {/* TAB (GLASS) */}
                <div
                    className="absolute -top-4 left-0 w-1/3 h-6 rounded-t-lg border-t border-l border-r border-white/30 backdrop-blur-xl"
                    style={{
                        background: `
                            linear-gradient(135deg, rgba(255,255,255,0.5), rgba(255,255,255,0.1)),
                            radial-gradient(circle at top, white 10%, transparent 60%)
                        `,
                    }}
                />

                {/* TOP LIQUID SHINE */}
                <div className="absolute inset-0 rounded-xl opacity-60 pointer-events-none"
                    style={{
                        background:
                            "radial-gradient(circle at 20% 0%, rgba(255,255,255,0.8), transparent 60%)",
                    }}
                />

                {/* EDGE GLOW */}
                <div className="absolute inset-0 rounded-xl pointer-events-none"
                    style={{
                        boxShadow: `0 0 25px ${color}60 inset`,
                    }}
                />
            </div>
        </div>
    );
};

export default LiquidFolder;
